export let variantListProps = {
    key: 0,
    id: 0,
    variant_sub_item_id: null,
    other_variations: []
}

export let otherVariantListProps = {
    key: 0,
    sku_code: '',
    other_variations: []
}

export let logProps = {
    id: 0,
    service_date: '',
    activity_type: 0,
    supervised_by_staff_id: null,
    service_done_by_contact_id: null,
    notes: '',
    image: ''
}

export let imageListProps = {
    key: 0,
    id: 0,
    image_path: '',
    display_online: true,
    default_online_thumbnail: false,
    default_online_thumbnail_hover: false
}

export let estorePriceVariationSource = {
    key: 0,
    source_name: '',
    source_link: '',
    source_self: true
}

export let estorePriceVariation = {
    key: 0,
    variation_title: '',
    variation_source: [JSON.parse(JSON.stringify(estorePriceVariationSource))],
    price: 0,
    price_currency_id: 0,
    coming_soon: false,
    display_to_self_country: true,
    loading: false
}

export let estoreDownloadable = {
    key: 0,
    source_name: '',
    source_link: ''
}

export let dataProps = {
    id: 0,
    item_type: 0, 
    fabric_cut_length: false,
    fabric_can_be_sold_as_retail: true,
    auto_generated_sku_code: 0, 
    sku_code: '', 
    sub_category_id: null,
    article_name: '', 
    composition: '',
    design_description: '', 
    unit_of_measurement_id: null, 
    cost_price: 0, 
    sale_price: 0, 
    reorder_level: 0, 
    fabric_width_id: null, 
    fabric_price_category_id: null, 
    style_number: '', 
    fabric_gsm_id: null,
    hsn_sac_code: '', 
    tax_percent: 0, 
    profile_photo: '',
    most_popular: false,
    brand_name: '',
    trade_name: '',
    shade_number: '',
    rack_id: [],
    account_sub_category_id: null,
    issued_to: 0,
    caretaker_id: 0,
    purchase_date: '',
    warranty_expiry_date: '',
    log_list: [],
    stitching_rate_flat: false,
    discount_percent: 0,
    flat_price: 0,
    store_id: 0,
    length: '',
    width: '',
    height: '',
    default_retail_fabric_unit: 0,
    copies: 0,
    cluster_id: null,
    alteration_allowed: false,
    alteration_tailoring_item_id: 0,
    default_tailoring_consumption: 0,
    collection_id: null,
    
    estore_available: false,
    estore_price_variation: [JSON.parse(JSON.stringify(estorePriceVariation))],
    estore_product_variation: [],
    estore_title: '',
    estore_sub_title: '',
    estore_overview: '',
    estore_other_detail: '',
    estore_downloable: [JSON.parse(JSON.stringify(estoreDownloadable))],
    estore_stylist_names: [],//fetch from contacts
    estore_price_variation_available: false,
    estore_placement: 0,
    estore_featuring_title: '',
    estore_featuring_content: '',

    estore_preview_title1: '',
    estore_preview_title2: '',
    estore_preview_title3: '',
    estore_preview_content: '',
    profit_percent: 0,
    vendor_id: null,
    
    variant_item_id: 0,
    other_variations: [JSON.parse(JSON.stringify(otherVariantListProps))],
    image_list: [JSON.parse(JSON.stringify(imageListProps))],
    delete_image_list: [],    
    variant_list: [JSON.parse(JSON.stringify(variantListProps))],  
    other_variation_item_list: []  
}


// WEBPACK FOOTER //
// ./src/store/modules/inventoryMaster/properties.js